import React, { useState } from 'react';
import { Input } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import RelatedApprovalDetailModal from '../ProcessDetail/RelatedApprovalDetailModal';

export default function RelatedApprovalNoField({
  value,
  onChange,
  disabled,
  relatedApprovalId,
  relatedApprovalBizType,
  relatedInboundIds = []
}) {
  const [detailOpen, setDetailOpen] = useState(false);
  const isMatInbound = relatedApprovalBizType === 'mat_inbound';
  const canView = isMatInbound
    ? relatedInboundIds.length > 0
    : Boolean(relatedApprovalId && relatedApprovalBizType);

  return (
    <>
      <Input
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={isMatInbound ? '转报销时自动带入入库单号' : '选填，转报销时自动带出'}
        suffix={canView ? (
          <EyeOutlined
            role="button"
            tabIndex={0}
            aria-label="查看关联审批单"
            style={{ color: '#1677ff', cursor: 'pointer' }}
            onClick={() => setDetailOpen(true)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setDetailOpen(true);
              }
            }}
          />
        ) : null}
      />
      <RelatedApprovalDetailModal
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        approvalId={relatedApprovalId}
        bizType={relatedApprovalBizType}
        relatedInboundIds={relatedInboundIds}
      />
    </>
  );
}
